'use client';

import Image from 'next/image';
import React from 'react';

import {
    Alignable,
    Box,
    BoxContent,
    BoxHeader,
    Button,
    ButtonList,
    ButtonListDirectionEnum,
    ButtonVariant,
    Column,
    Columns,
    Container,
    Icon,
    IconName,
    IconSize,
    Justifiable,
    Row,
    Rows,
    Spacer,
    SpacerSize,
    Text,
    TextLevels,
    Title,
    TitleLevels,
    TypographyAlign,
    TypographyBold,
    View,
} from '@bytel/trilogy-react';

import { getAppConfig } from '@services/config';

const config = getAppConfig();

export function OfferRenewalSkeleton() {
    return (
        <Container>
            <Columns align={Alignable.ALIGNED_CENTER} className='is-hidden-mobile'>
                <OfferCardContainerSkeleton isCurrent />
                <OfferCardContainerSkeleton />
                <OfferCardContainerSkeleton />
            </Columns>
            <View className='is-hidden-tablet'>
                <OfferCardContainerSkeleton isCurrent />
                <OfferCardContainerSkeleton />
                <OfferCardContainerSkeleton />
            </View>
        </Container>
    );
}

export function OfferCardContainerSkeleton({ isCurrent = false }: { isCurrent?: boolean }) {
    return (
        <Column className='h-auto' size={4}>
            <Rows>
                <Row narrow>
                    <Box className='is-loading'>
                        <Columns>
                            <Column narrow className='is-flex'>
                                <Image
                                    src={`${config.assets.cmsImages.url}/wall/lazyload-phone-default-image.svg`}
                                    alt=''
                                    width={55}
                                    height={110}
                                />
                            </Column>
                            <Column className='has-text-centered-mobile'>
                                <div>
                                    <Text typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD} level={TextLevels.FOUR}>
                                        Lorem ipsum in
                                    </Text>
                                </div>
                                <Text style={{ fontSize: '24px' }}>Lorem</Text>
                                <Spacer size={SpacerSize.FIVE} />
                            </Column>
                        </Columns>
                    </Box>
                </Row>
                <Row narrow>
                    <View flexable fullwidth className='is-centered'>
                        <Icon size={IconSize.SMALL} name={IconName.PLUS_CIRCLE} />
                    </View>
                </Row>
                <Row>
                    <Box headerOffset={!isCurrent}>
                        {isCurrent && (
                            <BoxHeader className='is-justified-center'>
                                <Text level={TextLevels.ONE} marginless typo={TypographyAlign.TEXT_CENTERED}>
                                    Mon forfait actuel
                                </Text>
                            </BoxHeader>
                        )}
                        <BoxContent className='is-loading has-text-left'>
                            <Spacer size={SpacerSize.TWO} />
                            <Title level={TitleLevels.THREE}>
                                <Columns mobile>
                                    <Column>
                                        <Text style={{ fontSize: '35px' }}>Lorem ips</Text>
                                    </Column>
                                </Columns>
                            </Title>
                            <Text style={{ fontSize: '28px' }}>Lorem ipsum in</Text>
                            <View className='blocked-plan'></View>
                            <Spacer size={SpacerSize.SIX} />
                            <View justify={Justifiable.JUSTIFIED_CENTER} align={Alignable.ALIGNED_CENTER} flexable>
                                <Text style={{ fontSize: '32px' }}>Lorem i</Text>
                            </View>
                            <Spacer size={'110'} />
                            <ButtonList direction={ButtonListDirectionEnum.COLUMN} className='gap-medium'>
                                <Button type='button' variant={ButtonVariant.CONVERSION} fullwidth disabled>
                                    Conserver ce forfait
                                </Button>
                                <Button type='button' variant={ButtonVariant.SECONDARY} fullwidth disabled>
                                    Voir plus de détails
                                </Button>
                            </ButtonList>
                        </BoxContent>
                    </Box>
                </Row>
            </Rows>
        </Column>
    );
}
